export default {
    tagRule(state) {
        return state.tagRule;
    },
    tag(state) {
        return state.tag;
    },
    workspaceTag(state) {
        return state.workspaceTag;
    },
    workspaceTagForSelect(state) {
        const tags = [];

        for (const index in state.workspaceTag) {
            const tagItem = {
                id: state.workspaceTag[index].id,
                text: state.workspaceTag[index].text + ` (${state.workspaceTag[index].description})`
            }
            
            tags.push(tagItem);
        }

        return tags;
    }
}